angular.module('jv.Common.AccessGroupSelect', [])

.directive('jvAccessGroupSelect', ['$timeout', 'url', function($timeout, url){
    return {
        require: 'ngModel',
        link: function($scope, iElm, iAttrs, controller) {
            var filter = $scope.$eval(iAttrs.jvAccessGroupSelectFilter),
                isMultiple = (iAttrs.jvAccessGroupSelect === 'multiple'),
                accessGroupUrl = jvUrls.admin + '/action/accessGroups/dropdown?',
                changed = false;
            var config = $.extend({},{
                id:'code',
                multiple: isMultiple,
                allowClear: angular.isDefined(iAttrs.jvAccessGroupSelectAllowClear),
                ajax: {
                    quietMillis: 500,
                    url: accessGroupUrl,
                    data: function (term, page) {
                        var pageSize = term && 10 || 50,
                            result = {
                                keywords: term,
                                filterDropdown : filter,
                                pageSize: pageSize,
                                pageNumber: page - 1
                            };
                        return result;
                    },
                    results: function (data, page) {
                        var accessGroups = data.accessGroupsDropdownList || [],
                            more = Boolean(accessGroups.length);

                        return {
                            results: accessGroups,
                            more: more
                        };
                    }
                },
                formatResult: function (accessGroup) {
                    var formatHtml = "<div class='small'><strong>"+ accessGroup.name +"</strong></div><div>" + accessGroup.code + "</div>"
                    return formatHtml;
                },
                formatSelection: function (accessGroup) {
                    return accessGroup.name;
                },
                initSelection: function(element, callback) {
                   if (angular.isDefined(controller.$modelValue) && controller.$modelValue && controller.$modelValue !==null) {
                       callback(controller.$modelValue);
                    } else {
                       var data = {};
                       callback(data);
                   }
                }
            }, window._jvPluginDefaults.select2);

            iElm.select2(config).on('change', function(e) {
                changed = true;
                $scope.$apply(function() {
                    var val = e.val;
                    if (iAttrs.jvAccessGroupSelectObj !== undefined && iAttrs.jvAccessGroupSelectObj !== false) {
                        val = iElm.select2('data');
                    }
                    controller.$setViewValue(val);
                });
            });

            $scope.$watch(iAttrs.ngModel, function(accessGroups, oldAccessGroups) {
                if (!changed && ((isMultiple && accessGroups && accessGroups.constructor === Array && accessGroups.length > 0) || (!isMultiple && accessGroups)) ) {
                    iElm.select2('val', accessGroups);
                }
                if (!accessGroups || accessGroups.length === 0) {
                    iElm.select2('val', '');
                }
                changed = false;
            });

            $scope.$on('$destroy', function() {
                iElm.select2('destroy');
            });
        }
    };
}]);
